<template>
  <v-container>
    <v-row class="text-center">
      <v-col class="ma-0 pa-0" cols="12">
        <v-img
            :src="require('../assets/ls-h-branco.svg')"
            contain
            height="60"
        />
      </v-col>
    </v-row>
    <div v-if="!this.$store.state.list">
      <v-card
          class="mx-auto"
          max-width="344"
      >
        <v-card-text>
          <v-alert>Nenhuma lista de participantes foi carregada</v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              @click="$router.push({name: 'LoadList'})"
          >
            Carregar Participantes
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </div>
    <div v-else id="dice">
      <div class="example-3d">
        <swiper ref="mySwiper" :options="swiperOption" class="swiper">
          <swiper-slide v-for="person in virtualData" :key="person.number">
            <v-card
                class=""
                dark ma-0
                pa-0
                style="height: 100%; width: 100%;"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-avatar size="128">
                    <img :src="person.avatar"/>
                  </v-avatar>
                </v-list-item-content>
              </v-list-item>
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title class="mb-1" style="font-size: 2.5rem!important;">{{ person.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>{{ person.hiddenEmail }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-card-actions>
              </v-card-actions>
            </v-card>
          </swiper-slide>
        </swiper>
      </div>
      <v-row class="text-center">
        <v-col class="ma-0 pa-0" cols="12">
          <v-spacer></v-spacer>
          <v-btn :loading="loading" color="success" x-large @click="loadData()">
            Sortear
          </v-btn>
          <v-spacer></v-spacer>
        </v-col>
      </v-row>
    </div>
    <div :class="{'my-overlay': showAnimation}">
      <lottie :height="animationSize" :options="animationOptions"
              :style="'height: '+ animationSize + 'px; width: ' + animationSize + ';'"
              @animCreated="handleAnimation"/>
    </div>
    <v-dialog v-if="pickedUp"
              v-model="dialog"
              max-width="450"
    >
      <v-card>
        <v-card-title class="headline">Confirma o Vencedor?</v-card-title>
        <person-card :flat="true" :model="this.virtualData[pickedUp]"></person-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="green darken-1"
              text
              @click="winnerCancel"
          >
            Cancelar
          </v-btn>

          <v-btn
              color="green darken-1"
              text
              @click="winnerConfirm"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import Lottie from 'vue-lottie'
import * as animationData from '../assets/animations/7893-confetti-cannons.json'
import PersonCard from "../components/PersonCard";
import {Random} from "random-js";
import {mapActions} from "vuex";

const random = new Random(); // uses the nativeMath engine

export default {
  components: {
    PersonCard,
    Swiper,
    SwiperSlide,
    Lottie
  },
  data: () => ({
    dialog: false,
    animationSize: 10,
    anim: null,
    animationOptions: {
      animationData: animationData.default,
      loop: true,
      autoplay: false,
      rendererSettings: { preserveAspectRatio: 'xMidYMid slice' }
    },
    removeFromNextRound: null,
    showAnimation: false,
    sliceSize: 120,
    pickedUp: 0,
    loading: false,
    people: [],
    audio: new Audio(require('../assets/peao-do-bau.mp3')),
    virtualData: [],
    swiperOption: {
      loop: true,
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 'auto',
    }
  }),
  created () {
    this.people = this.$store.state.list
  },
  mounted () {
    this.virtualData = []
    let _self = this
    this.swiper.on('click', function () {
      _self.pickedUp = _self.swiper.clickedSlide.getAttribute('data-swiper-slide-index')
      console.debug('ClickedIndex: ', _self.swiper.clickedIndex)
      console.debug('ClickedSlide: ', _self.swiper.clickedSlide)
      _self.showConsoleInfo('CONFIRMANDO SORTEADO')
      // _self.$store.commit('addConfirming', _self.virtualData[_self.pickedUp])
      _self.addConfirming(_self.virtualData[_self.pickedUp])
      _self.dialog = true
    })
    this.loadVirtualData()
    this.$nextTick()
        .then(function () {
          // console.log('tick')
        })
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.$swiper
    },
    winner (idx) {
      return this.virtualData[idx]
    }
  },
  methods: {
    loadData () {
      // this.pickedUp = Math.floor(Math.random() * this.people.length);
      // this.loadVirtualData()
      this.$nextTick()
          .then(function () {
            // console.log('tick')
          })
      this.lottery()
    },
    lottery () {
      const lastWinnerIndex = this.pickedUp
      let tempPicked = lastWinnerIndex
      // const _self = this
      /*			console.log('virtualData.length: ', this.virtualData.length)
                    console.log('tempPicked: ', tempPicked)
            console.log('lastWinnerIndex: ', lastWinnerIndex)
            console.log('sliceSize / 3: ', this.sliceSize / 3)
      */

      //Remove last winner from Virtual data
      if (this.removeFromNextRound) {
        this.removeFromVirtualList(this.removeFromNextRound)
        this.removeFromNextRound = null
      }

      while (Math.abs(tempPicked - lastWinnerIndex) <= (this.virtualData.length / 3)) {
        tempPicked = Math.floor(random.integer(1, this.virtualData.length))
      }
      // console.log('index = ', tempPicked)
      //TODO: Validate if is allowed to repeat the winner
      this.pickedUp = tempPicked

      this.playSound('')
      this.swiper.slideTo(tempPicked + (2 * this.virtualData.length), 23000, false)
    },
    winnerCancel () {
      this.dialog = false
      this.clearConfirming()
    },
    winnerConfirm () {
      this.showConsoleInfo('CONFIRMANDO SORTEADO')
      this.setWinner()
      this.clearConfirming()
      this.dialog = false
    },
    removeFromVirtualList(idx) {
      this.virtualData.splice(idx, 1);
    },
    setWinner () {
      this.showConsoleInfo()
      let lucky = this.pickedUp
      this.addWinner(this.virtualData[lucky])
      this.removeItemFromList(this.virtualData[lucky])
      this.showConfettiAnimation()
      this.removeFromNextRound = lucky
      // this.removeFromVirtualList(lucky)
    },
    showConsoleInfo (processInfo = 'SORTEADO') {
      let lucky = this.pickedUp
      console.debug('activeIndex: ', this.swiper.activeIndex, ' - loopedSlides: ', this.swiper.loopedSlides, ' - realIndex: ', lucky, this.swiper)
      console.info('- - - - - - - ' + processInfo + '- - - - - - - - ');
      console.info('Nome na Roleta: ', this.virtualData[lucky].name);
      console.info('Nome preenchido: ', this.virtualData[lucky].fullName);
      console.info('Email: ', this.virtualData[lucky].email);
      console.info('Telefone: ', this.virtualData[lucky].phone);
      console.info('- - - - - - - - - - - - - - - - - - - - - ');
    },
    playSound (sound) {
      sound = require('../assets/peao-do-bau.mp3')
      if (sound) {
        var audio = new Audio(sound);
        audio.onended = () => {
          // this.showConfettiAnimation()
          /*
                                              this.loading = false
                                              this.showConfettiAnimation()
                      */
        }
        audio.play();
      }
    },
    loadVirtualData (length = this.sliceSize) {
      if (!this.$store.state.list) return
      let _self = this
      _self.$nextTick()
          .then(function () {
            // _self.loading = true
            // console.log('loading virtual ...')
          })
      let tempSlides = []
      console.log('Loading size: ', length)
      let index = 0
      let p = undefined
      this.virtualData = []
      _self.swiper.slideTo(0, 0, false)
      if (length >= this.$store.state.list.length) {
        _self.virtualData = this.people
      } else {
        let counter = 0
        for (counter = 0; counter < length - 1; counter++) {
          index = random.integer(1, this.people.length)
          p = this.people[index]
          if (p !== undefined) tempSlides.push(p)
        }
        const unique = [...new Set(tempSlides)];
        _self.virtualData = unique
      }

      // this.sleep(1000)
      _self.$nextTick()
          .then(function () {
            _self.loading = false
            // console.log('setting loaging false')
          })
      _self.swiper.slideTo(0, 200, false)
      // this.sliceSize = _self.virtualData.length
      this.loading = false
    },
    handleAnimation: function (anim) {
      console.log('animation created')
      this.anim = anim;
    },
    showConfettiAnimation () {
      this.animationSize = window.innerWidth
      this.showAnimation = true
      const _this = this
      //console.log('showing the animation...')
      if (_this.anim) _this.anim.play()
      setTimeout(function () {
        //console.log('a few seconds after...')
        _this.showAnimation = false
        _this.animationSize = 1
        if (_this.anim) _this.anim.stop()
      }, 4200)
    },
    ...mapActions(['addWinner', 'addConfirming', 'clearConfirming', 'removeItemFromList'])
  },
}
</script>

<style lang="scss" scoped>
.example-3d {
  max-width: 100%;
  height: 350px;
  padding-top: 20px;
  padding-bottom: 20px;
}

.swiper {
  height: 100%;
  width: 100%;

  .swiper-slide-3d {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 300px;
    height: 300px;
    text-align: center;
    font-weight: bold;
    font-size: 33px;
    background-color: #2C8DFB;
    background-position: center;
    background-size: cover;
    color: white;
  }

  .swiper-slide {
    text-align: center;
    font-size: 72px;
    background: #1E1E1E;
    color: white;
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }
}

.my-overlay {
  align-items: center;
  display: flex;
  justify-content: center;
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
}
</style>
